import Select from 'react-select';
import React from 'react';
import { SingleValue } from 'react-select';
import { useNavigate, useParams } from 'react-router-dom';
import { useUserContext } from 'src/context/UserProvider';
import { useGetDrivePositionsQuery } from 'src/hooks/drives.hooks';
import { PositionDocument, UserCareerPathType } from 'types';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { formatCareerPathType } from 'shared-utils';

const DrivePositionSelect = () => {
	const navigate = useNavigate();
	const { isAccountManagerLoggedIn } = useUserContext();
	const { company: companyId, id: positionId } = useParams();
	const { data, isLoading } = useGetDrivePositionsQuery({
		data: {
			name: '',
			lightweight: true,
			...(isAccountManagerLoggedIn && companyId ? { companyId: companyId || '' } : {}),
		},
		enabled: !isAccountManagerLoggedIn || !!companyId,
	});

	const allPositions = [...(data?.openPositions || []), ...(data?.closedPositions || [])];

	const selectedPosition = allPositions?.find(o => o._id === positionId);

	dayjs.extend(advancedFormat);
	const createSelectLabel = (position: PositionDocument) => {
		return `${formatCareerPathType(position.title as UserCareerPathType)} | ${position.registeredDrive?.city} - ${dayjs(
			position.registeredDrive?.driveDate,
		).format('Do MMM')}`;
	};

	return (
		<Select
			className="w-full md:w-[320px] !font-[400] !text-[16px] whiteBgSelect"
			menuPlacement={'auto'}
			classNamePrefix="my-select-plans"
			closeMenuOnSelect
			isLoading={isLoading}
			noOptionsMessage={() => (isLoading ? 'Loading positions...' : 'No positions found')}
			options={allPositions.map(position => ({
				label: createSelectLabel(position),
				value: position._id,
			}))}
			value={
				selectedPosition ? { label: createSelectLabel(selectedPosition), value: selectedPosition?._id } : undefined
			}
			onChange={(
				val: SingleValue<{
					label: string;
					value: string;
				}>,
			) => {
				if (val?.value) {
					const selectedDriveId = allPositions.find(p => p._id === val.value)?.registeredDrive?._id || '';
					navigate(
						`/drive-positions/candidates/${isAccountManagerLoggedIn ? `${companyId}/` : ''}${
							val.value
						}?role=${encodeURIComponent(JSON.stringify([allPositions.find(p => p._id === val.value)?.title]))}${
							selectedDriveId ? `&driveId=${selectedDriveId}` : ''
						}`,
					);
				}
			}}
		/>
	);
};

export default DrivePositionSelect;
